import { useState, useEffect, useRef } from "react";

import postIcon from "./img/papierflieger.webp";
import flyerIcon from "./img/flyer.webp";
import gearIcon from "./img/gear.png";
import sharepointIcon from "./img/spIcon.svg";
import { useConfig } from "./ConfigContext";

import { api } from "./pureFunctions";
import { header, host } from "./globalVariables";

import ProjektListeOptionen from "./ProjektListeOptionen";
import React from "react";
import { getKacheln } from "./networkFunctions";
import { filterProjektStufenStatus, getStaticData } from "./pureFunctions";
import { statusfarben, statusfarbentext } from "./globalVariables";

const initialListOpt = {};

function EstateUebersicht({ user }) {
   const config = useConfig();
   const [estatekacheln, setEstatekacheln] = useState();
   const [filteredkacheln, setFilteredkacheln] = useState();
   const [showMenu, setShowMenu] = useState(false);
   const [estateId, setEstateId] = useState();
   const [filterbutton, setFilterbutton] = useState("alle");
   const [users, setUsers] = useState();
   const [listenOptionen, setListenOptionen] = useState(() => {
      const oldOptions = JSON.parse(localStorage.getItem("pListOpt"));
      return oldOptions ? oldOptions : initialListOpt;
   });

   const [estates, setEstates] = useState([]);

   const [filter, setFilter] = useState({
      objektnr_extern: { regex: "", title: "Filter", value: "" },
   });

   async function getSingleObject(objNr) {
      let parameters = {
         data: [
            "strasse",
            "hausnummer",
            "plz",
            "ort",
            "objektnr_extern",
            "benutzer",
            config.estate.ordnerName, //ordnerName
            config.estate.eskalationsdaten, //Eskalationsdaten
            config.estate.kachelstatus, //Kachelstatus
            config.estate.projektstatus, //Projektstatus
            config.estate.objektBezeichnung, //Objektbezeichnung
         ],
         filter: {
            status: [{ op: "=", val: "1" }],
         },
         listlimit: 500,
         listoffset: 0,
         sortby: { objektnr_extern: "DESC" },
      };
      parameters.filter = { objektnr_extern: [{ op: "IN", val: [objNr] }] };

      let respdata = await readEstates(parameters, filteredkacheln, users);

      console.log(respdata);
      setEstates((prev) => [...prev, ...respdata]);
   }

   async function readEstates(parameters, newFilteredkacheln, cleanUserData) {
      return await api.post("/api/readEstates", { parameters }, header).then((data) => {
         const respdata = data.data.map((estate, index) => {
            const projektstatus = estate.elements[config.estate.projektstatus]
               ? JSON.parse(estate.elements[config.estate.projektstatus])
               : "";
            const kachelstatus = estate.elements[config.estate.kachelstatus]
               ? JSON.parse(estate.elements[config.estate.kachelstatus])
               : "";
            const eskalationsdaten = estate.elements[config.estate.eskalationsdaten]
               ? JSON.parse(estate.elements[config.estate.eskalationsdaten])
               : "";
            const aktiveEsk = [];
            const aktiveEskalationen = {};

            filterProjektStufenStatus(newFilteredkacheln, projektstatus, kachelstatus, eskalationsdaten);

            return {
               id: estate.id,
               elements: estate.elements,
               objektnr_extern: estate.elements.objektnr_extern,
               sharepointOrdner: estate.elements[config.estate.ordnerName],
               eskalationsdaten: eskalationsdaten,
               kachelstatus: kachelstatus,
               projektstatus: projektstatus,
               aktiveEsk: aktiveEsk,
               aktiveEskalationen: aktiveEskalationen,
               objektbezeichnung: estate.elements[config.estate.objektBezeichnung],
               kuerzel: cleanUserData[estate.elements.benutzer] ? cleanUserData[estate.elements.benutzer].Kuerzel : "",
               benutzername: cleanUserData[estate.elements.benutzer]
                  ? cleanUserData[estate.elements.benutzer].Vorname +
                    " " +
                    cleanUserData[estate.elements.benutzer].Nachname
                  : "",
            };
         });

         return respdata;
      });
   }

   async function getData() {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();

      setEstatekacheln(newestatekacheln);
      const newFilteredkacheln = Object.values(newestatekacheln)
         .map((item) => item.kachel)
         .flat()
         .reduce((oldObj, item) => ({ ...oldObj, [item.kachelId]: item }), {});

      setFilteredkacheln(newFilteredkacheln);

      let parameters = {
         data: [
            "strasse",
            "hausnummer",
            "plz",
            "ort",
            "objektnr_extern",
            "benutzer",
            config.estate.ordnerName, //ordnerName
            config.estate.eskalationsdaten, //Eskalationsdaten
            config.estate.kachelstatus, //Kachelstatus
            config.estate.projektstatus, //Projektstatus
            config.estate.objektBezeichnung, //Objektbezeichnung
            "objekttitel",
            "energyClass",
            "heizungsart",
            "befeuerung",
            "energieausweis_gueltig_bis",
            "energieausweistyp",
            "anzahl_zimmer",
            "wohnflaeche",
            "objektart",
            "grundstuecksflaeche",
            "kaufpreis",
            "endenergiebedarf",
         ],
         filter: {
            status: [{ op: "=", val: "1" }],
         },
         listlimit: 500,
         listoffset: 0,
         sortby: { objektnr_extern: "DESC" },
      };
      if (listenOptionen.users && listenOptionen.users.length) {
         parameters.filter["benutzer"] = [{ op: "IN", val: listenOptionen.users }];
      }
      if (listenOptionen[config.estate.backofficekraft] && listenOptionen[config.estate.backofficekraft].length) {
         parameters.filter[config.estate.backofficekraft] = [
            { op: "IN", val: listenOptionen[config.estate.backofficekraft] },
         ];
      }
      if (listenOptionen.status && listenOptionen.status.length) {
         parameters.filter[config.estate.verkaufsStatus] = [{ op: "IN", val: listenOptionen.status }];
      }
      parameters.filter["status"] = [{ op: "IN", val: ["1", "2"] }];
      console.log(parameters);

      setUsers(cleanUserData.userObject);

      let respdata = await readEstates(parameters, newFilteredkacheln, cleanUserData.userObject);

      console.log(respdata);
      setEstates(respdata);
   }

   useEffect(() => {
      console.log(filteredkacheln);
      getData();
   }, []);

   function updateFilter(e, index) {
      const newfilter = structuredClone(filter);
      newfilter[index].value = e.target.value;
      setFilter(newfilter);

      if (
         !isNaN(e.target.value) &&
         e.target.value > 10000 &&
         !estates.some((item) => item.objektnr_extern === e.target.value)
      ) {
         getSingleObject(e.target.value);
         console.log(e.target.value);
      }
   }

   return (
      <div className="m-0 mt-3 m-md-5">
         <h4 className="text-center">
            Suche in {estates && <span style={{ fontWeight: 800 }}>{estates.length}</span>} Einträgen{" "}
         </h4>
         <div style={{ marginLeft: "25%", width: "50%", marginBottom: "10px", display: "flex", flexDirection: "row" }}>
            <ProjektListeOptionen
               users={users}
               listenOptionen={listenOptionen}
               setListenOptionen={setListenOptionen}
               getData={getData}
            />
            {Object.keys(filter).map((item, index) => {
               return (
                  <input
                     key={"key_" + item}
                     type="text"
                     className="form-control"
                     style={{ display: "block" }}
                     autoComplete="off"
                     name={item}
                     placeholder=""
                     value={filter[item].value}
                     onChange={(e) => updateFilter(e, item)}
                  />
               );
            })}
         </div>
         <div className="immobilienuebersicht">
            <table>
               <thead>
                  <tr>
                     <th className="text-center">ObjNr</th>
                     <th className="text-center">Ordner</th>
                     <th className="text-start" width="300">
                        Objektbezeichung
                     </th>
                     <th className="text-start"></th>
                     {/* <th className="text-start">Benutzer</th> */}
                  </tr>
               </thead>
               <tbody>
                  {filteredkacheln &&
                     estates.map((element, index) => {
                        let userfilter = true;
                        if (filterbutton === "meine") {
                           userfilter = element.benutzer === user.id;
                        }
                        if (
                           userfilter &&
                           (element.objektnr_extern.indexOf(filter.objektnr_extern.value.toLowerCase()) >= 0 ||
                              (element.objektbezeichnung
                                 ? element.objektbezeichnung
                                      .toLowerCase()
                                      .indexOf(filter.objektnr_extern.value.toLowerCase()) >= 0
                                 : false) ||
                              element.benutzername.toLowerCase().indexOf(filter.objektnr_extern.value.toLowerCase()) >=
                                 0)
                        ) {
                           return (
                              <tr
                                 key={"objekt_" + index}
                                 style={index === showMenu ? { backgroundColor: "#224d" } : {}}
                                 onClick={() => setShowMenu((prev) => (index === prev ? false : index))}
                              >
                                 <td className="text-center" style={{ width: "0", minWidth: "fit-content" }}>
                                    {element.objektnr_extern}
                                 </td>
                                 <td className="text-center" style={{ width: "0", minWidth: "fit-content" }}>
                                    {element.sharepointOrdner && config?.ms365?.active && (
                                       <a
                                          href={config.ms365.sharepointUrl + "/Immobilien/" + element.sharepointOrdner}
                                          target="_blank"
                                          style={{ color: "white", textDecoration: "none" }}
                                       >
                                          <img src={sharepointIcon} height={"24px"} alt="" />
                                          <span className="d-none d-md-inline ms-2">Sharepoint ↗</span>
                                       </a>
                                    )}
                                 </td>
                                 <td title={element.objektbezeichnung} style={{ overflow: "hidden" }}>
                                    {index === showMenu && (
                                       <span className="table-buttons">
                                          <a
                                             href={"/datenblatt?estateid=" + element.id}
                                             className="tablebutton me-1"
                                             title="Zum Objekt bearbeiten"
                                             onClick={(e) => {
                                                e.stopPropagation();
                                             }}
                                          >
                                             <img src={gearIcon} height={"24px"} alt="Objekt bearbeiten" />
                                          </a>
                                          <a
                                             href={"/bewertungsmappe?estateid=" + element.id}
                                             className="tablebutton me-1"
                                             title="Zum Bewertungsmappen-Erstellungstool (Expoteam)"
                                             onClick={(e) => {
                                                e.stopPropagation();
                                             }}
                                          >
                                             <img src={flyerIcon} height={"24px"} alt="Bewertungsmappenerstellung" />
                                          </a>
                                          <a
                                             href={
                                                "/datenblatt?estateid=" +
                                                element.id +
                                                "&stufe=bewertungsbestellung&kachel=bewertungsbestellung"
                                             }
                                             className="tablebutton me-1"
                                             title="Zur Bewertungsmappenbestellung"
                                             onClick={(e) => {
                                                e.stopPropagation();
                                             }}
                                          >
                                             <img src={postIcon} height={"24px"} alt="Bewertungsmappenbestellung" />
                                          </a>
                                          <a
                                             href={"/buzzer?estateid=" + element.id}
                                             className="tablebutton"
                                             title="Zum Buzzer"
                                             onClick={(e) => {
                                                e.stopPropagation();
                                             }}
                                          >
                                             🎉
                                          </a>
                                       </span>
                                    )}{" "}
                                    {element.objektbezeichnung}
                                 </td>
                                 <td>
                                    {index === showMenu
                                       ? Object.values(element.aktiveEskalationen).map((itemPS, index2) => (
                                            <React.Fragment key={"eskkey_" + index + "_" + index2}>
                                               |
                                               {itemPS.map((item) => (
                                                  <a
                                                     key={"esklinkitem_" + element.id + "_" + item}
                                                     href={
                                                        "/datenblatt?estateid=" +
                                                        element.id +
                                                        "&stufe=" +
                                                        filteredkacheln[item].projektId +
                                                        "&kachel=" +
                                                        item
                                                     }
                                                     className="list-kachel"
                                                     title={
                                                        estatekacheln[filteredkacheln[item].projektId].projektHeading +
                                                        " | " +
                                                        filteredkacheln[item].heading
                                                     }
                                                     onClick={(e) => {
                                                        e.stopPropagation();
                                                     }}
                                                  >
                                                     {item.toUpperCase()[0] + item.toUpperCase()[1]}
                                                  </a>
                                               ))}
                                               |
                                            </React.Fragment>
                                         ))
                                       : Object.keys(estatekacheln).map((item, index2) => {
                                            const psstatus = element.projektstatus[item];
                                            /* if (psstatus === 9 || psstatus === "-1" || psstatus === -1) {
                                               console.log(element.projektstatus);
                                               console.log(item);
                                            } */

                                            const currentcolor =
                                               psstatus === "esk"
                                                  ? "#f0f"
                                                  : statusfarben[psstatus]
                                                    ? statusfarben[psstatus]
                                                    : "#2240";
                                            const currenttextcolor =
                                               psstatus === "esk"
                                                  ? "#000"
                                                  : statusfarbentext[psstatus]
                                                    ? statusfarbentext[psstatus]
                                                    : "#224";
                                            return (
                                               <React.Fragment key={"eskclosekey_" + index + "_" + index2}>
                                                  <a
                                                     href={"/datenblatt?estateid=" + element.id + "&stufe=" + item}
                                                     style={{
                                                        textDecoration: "none",
                                                        border: "solid 3px #0000",
                                                        padding: "2px 8px",
                                                        borderRadius: "8px",
                                                        marginRight: "6px",
                                                        fontWeight: 600,
                                                        //   color: currentcolor,
                                                        borderColor: currentcolor,
                                                        color: currenttextcolor,
                                                        backgroundColor: currentcolor,
                                                     }}
                                                     title={estatekacheln[item].projektHeading}
                                                  >
                                                     {estatekacheln[item].projektKurzel}
                                                  </a>
                                               </React.Fragment>
                                            );
                                         })}
                                    {/* {Object.values(element.aktiveEskalationen).map(
                        (itemPS) => (
                          <React.Fragment>
                            |
                            {itemPS.map((item) => (
                              <a
                                href={
                                  "/datenblatt?estateid=" +
                                  element.id +
                                  "&stufe=" +
                                  filteredkacheln[item].projektId +
                                  "&kachel=" +
                                  item
                                }
                                className="list-kachel"
                                title={
                                  estatekacheln[filteredkacheln[item].projektId]
                                    .projektHeading +
                                  " | " +
                                  filteredkacheln[item].heading
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                              >
                                {item.toUpperCase()[0] + item.toUpperCase()[1]}
                              </a>
                            ))}
                            |
                          </React.Fragment>
                        )
                      )} */}
                                 </td>
                              </tr>
                           );
                        } else {
                           return null;
                        }
                     })}
               </tbody>
            </table>
         </div>
      </div>
   );
}

export default EstateUebersicht;
